import React from 'react';

import { withCapacitor } from '../../Util/Capacitors/hoc';
import ArticleBoxView from '../../Components/Classroom/Content/ArticleBox';

const ArticleBox = ({ capacitorContext, ...resProps }) => {
  const { isNative, openUrl } = capacitorContext;
  const handleLinkClick = (node) => {
    node.onclick = () => {
      openUrl(node.href);
      return false;
    };
  };
  // onLinkClick prop provide to handle open link format on article such as same tab, new tab and etc.
  return <ArticleBoxView onLinkClick={isNative ? handleLinkClick : undefined} {...resProps} />;
};

export default withCapacitor(ArticleBox);
